import styles from './WebPageHead.css';

function handleOffcanvas($node: HTMLElement) {
	const $offCanvas = $node.querySelector('[data-select="offCanvas"]') as HTMLElement|null;
	const $toggler = $node.querySelectorAll('[data-select="toggleOffCanvas"]');
	const header = $node.querySelector('[data-header]');

	if ($offCanvas && $toggler) {
		const toggleOffCanvas = (e: MouseEvent) => {
			const isVisible = $offCanvas.classList.contains(styles.isVisible);

			document.body.classList.toggle(styles.isOverlayed, !isVisible);
			$toggler.forEach($node => $node.classList.toggle(styles.hasTransition, !isVisible));
			$offCanvas.classList.toggle(styles.isVisible, !isVisible);
			header?.classList.toggle(styles.offCanvasIsVisible, !isVisible);
			e.preventDefault();
		}

		$node.querySelectorAll('[data-select="toggleOffCanvas"]').forEach($toggler => {
			$toggler.addEventListener('click', toggleOffCanvas, false)
		});
	}
};

function handleMainNavigation($node: HTMLElement) {
	const toggleSubitems = (e: MouseEvent) => {
		const $toggler = e.currentTarget as HTMLElement;
		const $collapsable = $toggler.nextSibling as HTMLElement|null;

		if ($collapsable) {
			const isCollapsed = $collapsable.dataset.isCollapsed === '1';

			$collapsable.dataset.isCollapsed = isCollapsed ? '0' : '1';
			$toggler.textContent = isCollapsed ? '-' : '+';
		}

		e.preventDefault();
	}

	$node.querySelectorAll('[data-select="toggleSubitems"]').forEach($toggler => {
		$toggler.addEventListener('click', toggleSubitems, false)
	});
};


export default ($node: HTMLElement) => {
	handleOffcanvas($node);
	handleMainNavigation($node);
	const offset = 50;

	window.addEventListener('scroll', () => {
		const header = $node.querySelector('[data-header]');

		if (window.scrollY >= offset) {
			header?.classList.add(styles.scrolled);
		} else {
			header?.classList.remove(styles.scrolled);
		}
	});
}
